import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import React, {useState} from 'react';
import { Button, Confirm, Icon } from 'semantic-ui-react';
import CustomPopup from '../util/CustomPopup';

import { FETCH_POSTS_QUERY } from '../util/graphql';

function DeleteButton({postId, commentId, callback}){
    const mutation = commentId? DELETE_COMMENT_MUTATION: DELETE_POST_MUTATION;
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteMutation] = useMutation(mutation, {
        update(proxy){
            setConfirmOpen(false);
            if(!commentId){
                const data = proxy.readQuery({
                    query: FETCH_POSTS_QUERY
                });
                let newData = data.getPosts.filter(post=> post.id !== postId);
                proxy.writeQuery({query: FETCH_POSTS_QUERY, data:{ getPosts:{ ...newData} } });
            }
            
            if(callback) callback();
        },
        variables: {
            postId,
            commentId
        }
    })
    return(
        <>
        <CustomPopup content={commentId?'delete comment':'delete post'}>
            <Button color='red' floated='right' onClick={()=>setConfirmOpen(true)}>
                <Icon name='trash' style={{ margin: 0}}/>
            </Button>
        </CustomPopup>
        
        <Confirm
            open={confirmOpen}
            onCancel={()=> setConfirmOpen(false)}
            onConfirm={deleteMutation}/>
        </>
    );
}

const DELETE_POST_MUTATION = gql`
    mutation deletePost($postId: ID!){
        deletePost(postId: $postId)
    }
`;

const DELETE_COMMENT_MUTATION = gql`
    mutation deleteComment($postId: ID!, $commentId: ID!){
        deleteComment(postId: $postId, commentId: $commentId){
            id
            comments{
                id
                username
                createdAt
                body
            }
            commentCount
        }
    }
`

export default DeleteButton;